module.exports = __webpack_public_path__ + "img/male.d4761937.png";